module.exports = __webpack_public_path__ + "static/media/3.7f7bb3e7.jpg";